import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from "react-redux";
import store from './state/store'
import '../node_modules/bootstrap-icons/font/bootstrap-icons.css';
import axios from 'axios';
import { sdlc } from './util/sdlcUtil';
import * as Sentry from "@sentry/react";

// Ensure all requests go to the appropriate host
axios.defaults.baseURL = sdlc.apiHostPrefix()
Sentry.init({
    dsn: "https://c95d54710be80213b9f1042a9f9f6004@o4510791179370496.ingest.us.sentry.io/4510791180746752",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});


ReactDOM.render(<Provider store={store}>
    <App />
    </Provider>, document.getElementById('root'));
